import * as types from './requestFormatTypes';
import { RequestFormatRequest } from '@/main/models/request/RequestFormatRequest';

export const getPayloadFormat = (request: RequestFormatRequest) => ({
  type: types.GET_PAYLOAD_FORMAT,
  payload: request,
});
